<template>
  <svg viewBox="-10 -10 68 68" fill-rule="evenodd" clip-rule="evenodd" baseProfile="basic">
    <polygon fill="#bcbcbc" points="23.974,4 6.97,14 6.97,34 23.998,44 40.97,34 40.97,14" />
    <line
      x1="7.97"
      x2="23.579"
      y1="33"
      y2="24.454"
      fill="none"
      stroke="#bcbcbc"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="2" />
    <line
      x1="23.972"
      x2="23.966"
      y1="5.903"
      y2="15.864"
      fill="none"
      stroke="#bcbcbc"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="2" />
    <line
      x1="39.97"
      x2="32.97"
      y1="33"
      y2="29"
      fill="none"
      stroke="#bcbcbc"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-miterlimit="10"
      stroke-width="2" />
    <polygon fill="#757575" points="23.974,4 6.97,14 6.97,34 23.97,24" />
    <polygon fill="#424242" points="23.981,14 40.97,14 40.97,34 23.971,24" />
    <polygon fill="#616161" fill-rule="evenodd" points="40.97,14 23.966,17 23.974,4" clip-rule="evenodd" />
    <polygon fill="#616161" fill-rule="evenodd" points="6.97,14 23.981,16.881 23.966,24 6.97,34" clip-rule="evenodd" />
    <polygon fill="#ededed" points="6.97,14 23.97,24 23.998,44 40.97,14" />
  </svg>
</template>
